import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["ForgotPasswordForm"] */ "/vercel/path0/src/app/auth/forgot-password/ui/ForgotPasswordForm.tsx");
